import React from 'react'
import SVG from 'react-inlinesvg'
import { CBox, RBox } from '../__styled'
import { Box, Typography } from '@mui/material'

interface InfoSlideViewProps {
  icon: string
  title: string
  description: string
}

const InfoSlideView = ({ icon, title, description }: InfoSlideViewProps) => {
  return (
    <CBox gap={3} p={'40px 48px 28px 32px'}>
      <RBox gap={'16px'} sx={{ alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '52px',
            height: '52px',
            borderRadius: '14px',
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <SVG
            src={icon}
            width={'28px'}
            height={'28px'}
            style={{ filter: 'brightness(0) invert(1)' }}
          />
        </Box>
        <Typography
          fontSize={'22px'}
          fontWeight={700}
          color={'white'}
          sx={{
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
      </RBox>
      <Typography
        fontSize={'16px'}
        fontWeight={500}
        lineHeight={'28px'}
        color={'rgba(255, 255, 255, 0.9)'}
        sx={{
          letterSpacing: '-0.01em',
        }}
      >
        {description}
      </Typography>
    </CBox>
  )
}

export default InfoSlideView
